/**
 * KAN-755: блок "Скидки на товар" в карточке товара каталога: действующие и
 * запланированные скидки (включая промокоды) с условиями и статусом.
 * Скидок нет: блок не показывается.
 */
import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { DISCOUNT_STATE_VIEW } from '@/lib/discountForm';
import type { ProductDiscountBrief } from '@/types/discount';

export function ProductDiscountsBlock({ discounts }: { discounts: ProductDiscountBrief[] | undefined }) {
  if (!discounts || discounts.length === 0) return null;
  return (
    <section className="rounded-lg border bg-white p-4" data-testid="product-discounts">
      <div className="mb-2 flex items-center justify-between gap-2">
        <h2 className="text-sm font-medium text-gray-800">Скидки на товар</h2>
        <Link to="/discounts" className="text-sm text-blue-600 hover:underline">
          Все скидки
        </Link>
      </div>
      <ul className="divide-y">
        {discounts.map((discount) => {
          const state = DISCOUNT_STATE_VIEW[discount.state] ?? { label: discount.state, variant: 'secondary' as const };
          return (
            <li key={discount.id} className="flex flex-wrap items-center gap-x-3 gap-y-1 py-2 text-sm">
              <span className="font-medium text-gray-900">{discount.name}</span>
              {discount.summary && <span className="text-gray-600">{discount.summary}</span>}
              <Badge variant={state.variant} className="ml-auto">
                {state.label}
              </Badge>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
